// File: frontend/src/pages/InvestorPitch/components/slides/InsuranceProcessSlide/InsuranceProcessSlide.js

import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { ANIMATION_VARIANTS } from '../../../constants/animations';
import styles from './InsuranceProcessSlide.module.css';

const ProcessStepCard = ({ number, title, description }) => {
  return (
    <div className={styles.processStep}>
      <div className={styles.stepHeader}>
        <div className={styles.stepNumber}>{number}</div>
        <h3 className={styles.stepTitle}>{title}</h3>
      </div>
      <p className={styles.stepDescription}>{description}</p>
    </div>
  );
};

const InsuranceProcessSlide = () => {
  const { t } = useLanguage();

  const processSteps = [
    {
      number: "01",
      title: t('investor_pitch.insurance_process.steps.quote.title', 'AI-Assisted Quoting'),
      description: t('investor_pitch.insurance_process.steps.quote.description', 'Intelligent data collection with 60% fewer questions')
    },
    {
      number: "02",
      title: t('investor_pitch.insurance_process.steps.underwriting.title', 'Automated Underwriting'),
      description: t('investor_pitch.insurance_process.steps.underwriting.description', 'Real-time risk assessment and pricing')
    },
    {
      number: "03",
      title: t('investor_pitch.insurance_process.steps.bind.title', 'One-Click Binding'),
      description: t('investor_pitch.insurance_process.steps.bind.description', 'Instant policy issuance and documentation')
    },
    {
      number: "04",
      title: t('investor_pitch.insurance_process.steps.service.title', 'Proactive Service'),
      description: t('investor_pitch.insurance_process.steps.service.description', 'AI-driven customer engagement and claims handling')
    }
  ];

  return (
    <motion.div
      className={styles.container}
      variants={ANIMATION_VARIANTS.stagger.container}
      initial="hidden"
      animate="visible"
    >
      <motion.div 
        className={styles.header}
        variants={ANIMATION_VARIANTS.fadeIn}
      >
        <h2 className={styles.title}>
          {t('investor_pitch.insurance_process.title', 'End-to-End Insurance Process')}
        </h2>
        {/* <p className={styles.subtitle}>
          {t('investor_pitch.insurance_process.subtitle', 'Our AI-powered platform streamlines the entire insurance lifecycle')}
        </p> */}
      </motion.div>

      <motion.div 
        className={styles.processStepsContainer}
        variants={ANIMATION_VARIANTS.stagger.container}
      >
        {processSteps.map((step, index) => (
          <motion.div 
            key={index} 
            className={styles.processStepWrapper}
            variants={ANIMATION_VARIANTS.stagger.item}
            custom={index}
          >
            <ProcessStepCard 
              number={step.number}
              title={step.title}
              description={step.description}
            />
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default InsuranceProcessSlide;